export const STATUS_META = {
  draft:                { label: "Draft",             cls: "bg-slate-100 text-slate-700 border-slate-300" },
  submitted:            { label: "Submitted",         cls: "bg-[#e8f2f2] text-[#2d6b6b] border-[#2d6b6b]/40" },
  hod_review:           { label: "Pending HOD",       cls: "bg-[#f9f4e8] text-[#b48a45] border-[#b48a45]/40" },
  admin1_review:        { label: "HOD Approved · Pending Admin-1",  cls: "bg-amber-100 text-amber-800 border-amber-300" },
  admin2_review:        { label: "Admin-1 Approved · Pending HOS",  cls: "bg-orange-100 text-orange-800 border-orange-300" },
  process_owner:        { label: "HOS Approved · In Fulfilment",    cls: "bg-indigo-100 text-indigo-800 border-indigo-300" },
  accounts:             { label: "Pending Accounts",  cls: "bg-blue-100 text-blue-800 border-blue-300" },
  transport_po_review:  { label: "Transport PO Review",              cls: "bg-[#e8f2f2] text-[#2d6b6b] border-[#2d6b6b]/40" },
  accounts_po_review:   { label: "Accounts PO Review",               cls: "bg-[#f9e8ec] text-[#7a1f2b] border-[#7a1f2b]/40" },
  final_po_fanout:      { label: "Final PO Fan-out",                 cls: "bg-indigo-100 text-indigo-800 border-indigo-300" },
  process_owner_review: { label: "Process Owner Review",             cls: "bg-indigo-100 text-indigo-800 border-indigo-300" },
  accounts_review:      { label: "Accounts",                          cls: "bg-blue-100 text-blue-800 border-blue-300" },
  service_po_review:    { label: "Service PO Review (CAO / Arun.D)",     cls: "bg-[#efe5f8] text-[#6b3fa0] border-[#6b3fa0]/40" },
  fnb_po_review:        { label: "F&B PO Review (Sandeep)",             cls: "bg-[#faeadd] text-[#a04f22] border-[#a04f22]/40" },
  print_hod_review:     { label: "HOD Review (Print)",                   cls: "bg-[#f9f4e8] text-[#b48a45] border-[#b48a45]/40" },
  print_fulfillment:    { label: "Print Fulfilment",                     cls: "bg-[#efe5f8] text-[#6b3fa0] border-[#6b3fa0]/40" },
  completed:            { label: "Completed",         cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  rejected:             { label: "Rejected",          cls: "bg-[#fcebe9] text-[#b3261e] border-[#b3261e]/40" },
  on_hold:              { label: "On Hold",           cls: "bg-yellow-100 text-yellow-800 border-yellow-300" },
};

export const STAGE_LABEL = {
  submitted: "Submitted",
  hod_review: "HOD Review",
  admin1_review: "Admin-1 Review",
  admin2_review: "Admin-2 Review (HOS)",
  process_owner: "Process Owner",
  accounts: "Accounts",
  transport_po_review: "Transport PO (Shivmohan)",
  accounts_po_review: "Accounts PO (Sangita)",
  final_po_fanout: "Final PO Fan-out",
  process_owner_review: "Process Owner",
  accounts_review: "Accounts",
  service_po_review: "Service PO (CAO / Arun.D)",
  fnb_po_review: "F&B PO (Sandeep)",
  fnb_po_fulfilment: "F&B PO Fulfilment (Sandeep)",
  fnb_po_completion: "F&B PO Completion (Sandeep)",
  stores_po_review: "Stores PO (CAO / Arun.D)",
  cao_review: "CAO Review",
  accounts_imprest_check: "Imprest Check (Sangita)",
  print_hod_review: "HOD Review (Print)",
  print_fulfillment: "Print Fulfilment (Print PO)",
  // Phase 22b — Transportation v22.0 stage labels.
  transport_po_ack: "Transport PO (Shivmohan — Acknowledge)",
  transport_accounts_ack: "Accounts Ack (Sangita / Amey)",
  transport_final_po_fulfill: "Final PO Fulfilment (Shivmohan)",
  transport_accounts_final: "Accounts Final (Sangita / Amey)",
  completed: "Completed",
  rejected: "Rejected",
  on_hold: "On Hold",
};

// Phase 20.2 — Print Job PO multi-status enum. Keys MUST match
// backend/workflow.PRINT_JOB_PO_STATUSES exactly. Only `work_done` is
// terminal (locks the record on action).
export const PRINT_JOB_PO_STATUSES = {
  work_done:             "Work Done (Print task completed) - Collect Prints",
  partial_work_done:     "Partial Work done - Printer got stuck (takes time to repair)",
  print_not_clear:       "Print not clear - check format",
  daily_limit_reached:   "Daily 750 prints - limit reached so considered to next day",
  printer_quality_issue: "Printer Quality Issue - takes time to repair",
  printer_error:         "Printer error - takes time to repair",
  print_rejected:        "Print Rejected",
  print_on_hold:         "Print on Hold - need to discuss with admin",
};
export const PRINT_JOB_PO_TERMINAL = "work_done";

export const WORKFLOW_STAGES = [
  "submitted", "hod_review", "admin1_review",
  "admin2_review", "process_owner", "accounts", "completed",
];

// Phase 5 v5.0 legacy — twin fan-out flow (locked for pre-Phase-5.2 tickets).
export const TRANSPORTATION_WORKFLOW_STAGES_V50 = [
  "submitted",
  "transport_po_review",
  "accounts_po_review",
  "admin1_review",
  "admin2_review",
  "final_po_fanout",
  "completed",
];

// Phase 5.2 — 9-stage flow with restored HOD + sequential single-actor fulfilment.
export const TRANSPORTATION_WORKFLOW_STAGES_V52 = [
  "submitted",
  "hod_review",
  "transport_po_review",
  "accounts_po_review",
  "admin1_review",
  "admin2_review",       // grey-out visually when admin2_skipped_at is set
  "process_owner_review",
  "accounts_review",
  "completed",
];

// Phase 22b — 8-stage flow (no Admin-2):
//   submitted → hod_review → transport_po_ack (Shivmohan "Acknowledged")
//     → transport_accounts_ack (Sangita OR Amey)
//     → admin1_review (Bursar)
//     → transport_final_po_fulfill (Shivmohan)
//     → transport_accounts_final (Sangita OR Amey)
//     → completed
export const TRANSPORTATION_WORKFLOW_STAGES_V22 = [
  "submitted",
  "hod_review",
  "transport_po_ack",
  "transport_accounts_ack",
  "admin1_review",
  "transport_final_po_fulfill",
  "transport_accounts_final",
  "completed",
];

// Back-compat export (defaults to v22 since new dashboards render against it).
export const TRANSPORTATION_WORKFLOW_STAGES = TRANSPORTATION_WORKFLOW_STAGES_V22;

/**
 * Pick the stage strip for a given Transportation requisition based on its
 * frozen `workflow_version` stamp. v22 → new 8-stage strip; v5.2 → 9-stage;
 * legacy (v5.0 / missing) → old 7-stage strip.
 */
export function getTransportationStages(workflow_version) {
  if (workflow_version === "22.0") return TRANSPORTATION_WORKFLOW_STAGES_V22;
  if (workflow_version === "5.2" || workflow_version === "9.0") return TRANSPORTATION_WORKFLOW_STAGES_V52;
  return TRANSPORTATION_WORKFLOW_STAGES_V50;
}

// Phase 6 — Service Requisition 8-stage strip.
export const SERVICE_WORKFLOW_STAGES = [
  "submitted",
  "hod_review",
  "service_po_review",
  "admin1_review",
  "admin2_review",         // Admin-2 always required for Service (no skip)
  "process_owner_review",
  "accounts_review",
  "completed",
];

// Phase 10 — Material/Service v10 5-stage strip (HOD dropped).
export const MATERIAL_SERVICE_V10_WORKFLOW_STAGES = [
  "submitted", "stores_po_review",
  "admin1_review", "admin2_review",
  "accounts_review", "completed",
];

// Phase 11 — Material/Service v11 8-stage strip (HOD reinstated).
export const MATERIAL_SERVICE_V11_WORKFLOW_STAGES = [
  "submitted", "hod_review",
  "stores_po_review",
  "admin1_review", "admin2_review",
  "process_owner_review", "accounts_review",
  "completed",
];
export const SERVICE_WORKFLOW_STAGES_V11 = MATERIAL_SERVICE_V11_WORKFLOW_STAGES;
export const MATERIAL_WORKFLOW_STAGES_V11 = MATERIAL_SERVICE_V11_WORKFLOW_STAGES;

// Phase 11 — Guest v11 3-stage strip.
export const GUEST_V11_WORKFLOW_STAGES = [
  "submitted", "cao_review", "admin1_review", "completed",
];

// Phase 17 — Guest v17 2-stage strip (no Admin-1).
export const GUEST_WORKFLOW_STAGES_V17 = [
  "submitted", "cao_review", "completed",
];

// Phase 16 — Pocket Money v16 strip (adds accounts_imprest_check).
export const POCKET_MONEY_V16_WORKFLOW_STAGES = [
  "submitted", "hod_review", "accounts_imprest_check",
  "admin1_review", "admin2_review", "process_owner_review", "completed",
];

// Phase 12 — Internal Maini Booking v12 3-stage strip.
export const MAINI_WORKFLOW_STAGES = [
  "submitted", "cao_review", "process_owner_review", "completed",
];

// Per-form-type stage label overrides. Used by `getStageLabelForForm` to
// give a stage the correct role name for a specific form (e.g., Maini's
// process_owner_review is Shivmohan.V, so the strip renders
// "Process Owner (Transport)" instead of the generic "Process Owner").
export const FORM_STAGE_LABEL_OVERRIDES = {
  maini: { process_owner_review: "Process Owner (Transport)" },
};

export function getStageLabelForForm(form_type, stage) {
  const override = (FORM_STAGE_LABEL_OVERRIDES[form_type] || {})[stage];
  return override || STAGE_LABEL[stage] || stage;
}

// Phase 7 — F&B v7 8-stage strip (Sandeep at PO + Fulfilment stages).
export const FNB_V7_WORKFLOW_STAGES = [
  "submitted", "hod_review",
  "fnb_po_review",
  "admin1_review", "admin2_review",
  "process_owner_review", "accounts_review",
  "completed",
];

// Phase 7 — Hotel / Travel v7 6-stage strip.
export const HOTEL_TRAVEL_V7_WORKFLOW_STAGES = [
  "submitted", "hod_review",
  "admin1_review", "admin2_review",
  "process_owner_review",
  "completed",
];

// Phase 13 — Hotel / Travel v13 7-stage strip (adds accounts_review).
export const HOTEL_TRAVEL_V13_WORKFLOW_STAGES = [
  "submitted", "hod_review",
  "admin1_review", "admin2_review",
  "process_owner_review",
  "accounts_review",
  "completed",
];
export const TRAVEL_WORKFLOW_STAGES_V13 = HOTEL_TRAVEL_V13_WORKFLOW_STAGES;
export const HOTEL_WORKFLOW_STAGES_V13 = HOTEL_TRAVEL_V13_WORKFLOW_STAGES;

// Phase 15 — F&B Cake v15.0 9-stage strip.
// Phase 15.1 — Same strip now applies to BOTH cake AND food_and_beverages.
export const FNB_V15_WORKFLOW_STAGES = [
  "submitted", "fnb_po_review", "hod_review",
  "accounts_imprest_check", "admin1_review", "admin2_review",
  "fnb_po_fulfilment", "accounts_review",
  "fnb_po_completion", "completed",
];
// Back-compat alias — old name used in imports.
export const FNB_CAKE_V15_WORKFLOW_STAGES = FNB_V15_WORKFLOW_STAGES;

// Phase 7 — Finance forms share Hotel/Travel v7 strip.
export const FINANCE_V7_WORKFLOW_STAGES = HOTEL_TRAVEL_V7_WORKFLOW_STAGES;

/**
 * Pick the correct stage strip based on form_type + workflow_version.
 * Transportation → version-aware; Service → 8-stage v6.0 strip.
 */
export function getFormStages(form_type, workflow_version) {
  if (form_type === "transportation") {
    return getTransportationStages(workflow_version);
  }
  // Phase 11 — Material/Service version-aware strip.
  if (form_type === "material" || form_type === "service") {
    if (workflow_version === "11.0") return MATERIAL_SERVICE_V11_WORKFLOW_STAGES;
    if (workflow_version === "10.0") return MATERIAL_SERVICE_V10_WORKFLOW_STAGES;
    if (form_type === "service") return SERVICE_WORKFLOW_STAGES;
    return WORKFLOW_STAGES;
  }
  if (form_type === "service") return SERVICE_WORKFLOW_STAGES;
  if (form_type === "fnb" && workflow_version === "15.0") return FNB_CAKE_V15_WORKFLOW_STAGES;
  if (form_type === "fnb" && workflow_version === "7.0") return FNB_V7_WORKFLOW_STAGES;
  if ((form_type === "hotel" || form_type === "travel") && workflow_version === "13.0") {
    return HOTEL_TRAVEL_V13_WORKFLOW_STAGES;
  }
  if ((form_type === "hotel" || form_type === "travel") && workflow_version === "7.0") {
    return HOTEL_TRAVEL_V7_WORKFLOW_STAGES;
  }
  if (["advance_requisition", "pocket_money", "advance_settlement", "reimbursement"].includes(form_type)) {
    // Phase 16 — pocket_money v16 uses an extended strip (adds imprest check + PO review).
    if (form_type === "pocket_money" && workflow_version === "16.0") {
      return POCKET_MONEY_V16_WORKFLOW_STAGES;
    }
    return FINANCE_V7_WORKFLOW_STAGES;
  }
  if (form_type === "guest") {
    // Phase 17 — new submissions use 2-stage v17 flow (no Admin-1).
    if (workflow_version === "17.0") return GUEST_WORKFLOW_STAGES_V17;
    if (workflow_version === "11.0") return GUEST_V11_WORKFLOW_STAGES;
    return WORKFLOW_STAGES.filter((s) => s !== "hod_review");
  }
  if (form_type === "maini") return MAINI_WORKFLOW_STAGES;
  return WORKFLOW_STAGES;
}

export const ROLE_LABEL = {
  applicant: "Applicant",
  hod: "HOD",
  admin1: "Admin-1 (Bursar)",
  admin1_alt: "Admin-1 Alt (CAO)",
  admin2: "Admin-2 (HOS)",
  process_owner: "Process Owner",
  super_admin: "Super Admin",
};
